const attributionElement = document.createElement('div');
attributionElement.setAttribute('id', 'googlePlaceApiAttributionElement');

export function findPlace(searchText) {
  let service = new google.maps.places.PlacesService(attributionElement);// eslint-disable-line no-undef

  const request = {
    fields: ['geometry.location'],
    query: searchText
  };

  return new Promise((resolve, reject) => {
    service.findPlaceFromQuery(request, function (results, status) {
      if (status === google.maps.places.PlacesServiceStatus.OK) { // eslint-disable-line no-undef
        const resultLocation = results[0].geometry.location;

        resolve({ lat: resultLocation.lat(), lng: resultLocation.lng() });
      } else {
        reject('Could not get google places api result');
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src/utils/placesApi.js